import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';
import { Rating } from '@mui/material';

const AppStoreReview = ({ className, appStoreReview, ...rest }) => {
  return (
    <Card className={className} sx={{ mb: '20px' }} {...rest}>
      <CardHeader
        subheader={
          <>
            <Rating
              name="size-small"
              defaultValue={appStoreReview.rating}
              size="small"
            />
            <Typography
              variant="subtitle"
              color="textSecondary"
              sx={{ ml: '6px' }}
            >
              By {appStoreReview.author}
            </Typography>
          </>
        }
        title={
          <Typography color="textPrimary" variant="h6">
            <a href={appStoreReview.link}>{appStoreReview.title}</a>
          </Typography>
        }
      />
      <CardContent>
        <Typography variant="body1">{appStoreReview.comment}</Typography>
      </CardContent>
    </Card>
  );
};

AppStoreReview.propTypes = {
  className: PropTypes.string,
  appStoreReview: PropTypes.object.isRequired,
};

export default AppStoreReview;
